import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useIsMobile } from '../../hooks/useMediaQuery';

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger'
}) {
  const isMobile = useIsMobile();

  const variantStyles = {
    danger: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
    warning: 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500',
    primary: 'bg-kindredly-blue hover:bg-kindredly-blue-dark focus:ring-kindredly-blue',
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  // MUI Dialog renders inside the modal stack, so it stays accessible
  // (not aria-hidden) even when opened on top of another MUI dialog.
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirm-dialog-title"
      PaperProps={{
        className: 'bg-white dark:bg-gray-800 shadow-2xl',
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        className="!text-xl !font-semibold !text-gray-900 dark:!text-white"
      >
        {title}
      </DialogTitle>
      <DialogContent className={isMobile ? 'flex-1' : ''}>
        <p className="text-gray-600 dark:text-gray-300">{message}</p>
      </DialogContent>
      <DialogActions
        className={`flex gap-3 p-6 pt-0 ${isMobile ? 'flex-col' : 'justify-end'}`}
      >
        {isMobile ? (
          <>
            <button
              onClick={handleConfirm}
              className={`px-4 py-3 min-h-[44px] rounded-lg text-white transition-colors w-full ${variantStyles[variant]}`}
            >
              {confirmText}
            </button>
            <button
              onClick={onClose}
              className="px-4 py-3 min-h-[44px] rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors w-full"
              autoFocus
            >
              {cancelText}
            </button>
          </>
        ) : (
          <>
            <button
              onClick={onClose}
              className="px-4 py-3 min-h-[44px] rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors min-w-[100px]"
              autoFocus
            >
              {cancelText}
            </button>
            <button
              onClick={handleConfirm}
              className={`px-4 py-3 min-h-[44px] rounded-lg text-white transition-colors min-w-[100px] ${variantStyles[variant]}`}
            >
              {confirmText}
            </button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
